import { FormHelperText } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import { withStyles } from "@material-ui/core/styles";
import { createBrowserHistory } from "history";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import Loader from "../../../src/components/Loader";
import { isuserexist, userRegister } from "../../modules/user/redux/action";
import "../../style";
import { isSuperAdmin } from "../Common/CheckAuthorization";
import Button from "../FormElement/Button";
import { validForm } from "../FormElement/FormValidator";
import InputFiled from "../FormElement/InputFiled";
import DataPolicy from "./DataPolicy";



const history = createBrowserHistory();

const styles = {
  root: {
    color: "#00bc84",
    "&$checked": {
      color: "#00bc84"
    }
  },
  checked: {}
};

class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        confirmPassword: "",
        streetAddress: "",
        town: "",
        state: "",
        zipCode: "",
        contactNo: null,
        farmName: "",
        farmSize: null
      },
      formErrors: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        streetAddress: "",
        town: "",
        state: "",
        zipCode: "",
        contactNo: "",
        farmName: "",
        farmSize: ""
      },
      termsAndConditionAccepted: false,
      allowDataSharing: false,
      isValid: true,
      Error: "",
      Success: false,
      fetchingComplete: true,
      openDataPolicy: false
    };
  }
  handleCheck = event => {
    let { name, type, value } = event.target;
    if (name === "termsAndConditionAccepted")
      this.setState({
        termsAndConditionAccepted: !this.state.termsAndConditionAccepted
      });
    else if (name === "allowDataSharing") {
      this.setState({
        allowDataSharing: !this.state.allowDataSharing
      });
    }
  };

  handleChange = event => {
    const { name, value } = event.target;
    if (name === "contactNo") {
      if (value.match(/^\d{0,15}?$/)) {
        this.updateState(name, value);
      }
    } else if (name === "street_address" || name === "town") {
      if (value.match(/^(.|\n){0,100}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "state" || name === "zipCode") {
      if (value.match(/^(.|\n){0,20}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "firstName" || name === "lastName") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "farmSize") {
      if (value.match(/^\d{0,10}(\.\d{0,2})?$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          user: {
            ...prevState.user,
            [name]: value
          },
          Error: "",
          Success: false,
          fetchingComplete: true
        };
      },
      () => {
        const { user } = this.state;
        const requiredFields = { ...user };
        delete requiredFields.farmSize;
        this.setState({
          isValid: validForm(this.state.formErrors, requiredFields)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.Error && this.props.Error !== nextProps.Error) {
      this.setState({ Error: nextProps.Error, fetchingComplete: true });
    }
    if (nextProps.Success && this.props.Success !== nextProps.Success) {
      this.setState({
        fetchingComplete: true,
        Success: nextProps.Success,
        user: {
          name: "",
          username: "",
          password: "",
          farmAddress: "",
          contactNo: "",
          farmName: "",
          farmSize: ""
        }
      });
    }
  }

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { user } = this.state;
        const requiredFields = { ...user };
        delete requiredFields.farmSize;
        this.setState({
          isValid: validForm(this.state.formErrors, requiredFields)
        });
      }
    );
  };

  onCancel = e => {
    e.preventDefault();
    history.goBack();
  };

  componentDidMount() {
    if (window.location.pathname.includes('inviteFarmer')) {
      const params = new URLSearchParams(window.location.search);
      const username = params.get('username');
      if (username) {
        this.setState(prevState => ({
          user: {
            ...prevState.user,
            username
          }
        }));
      }
    }
  }

  userSignup = e => {
    e.preventDefault();

    const { user, termsAndConditionAccepted, allowDataSharing } = this.state;
    const formData = { ...user };

    formData.address = {};
    delete formData.streetAddress;
    delete formData.zipCode;
    delete formData.town;
    delete formData.state;
    formData.address.streetAddress = user.streetAddress;
    formData.address.town = user.town;
    formData.address.state = user.state;
    formData.address.zipCode = user.zipCode;
    formData.termsAndConditionAccepted = termsAndConditionAccepted;
    formData.allowDataSharing = allowDataSharing;
    if (window.location.pathname.includes('inviteFarmer')) {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      if (code) formData['invitationCode'] = code;
    }
    this.setState({ isValid: true, fetchingComplete: false });
    this.props.actions.userRegister(formData);
  };

  validateResetForm = () => {
    const { password, confirmPassword } = this.state.user;
    if (confirmPassword !== "" || confirmPassword !== null)
      return password === confirmPassword;
    else return true;
  };

  openDataPolicyModal = () => {
    this.setState({openDataPolicy : true})
  }

  closeDataPolicyModal = () => {
    this.setState({openDataPolicy : false})
  }

  render() {
    const {
      user,
      isValid,
      Error,
      Success,
      fetchingComplete,
      termsAndConditionAccepted,
      allowDataSharing
    } = this.state;
    const { classes } = this.props;
    if (this.props.userData.user.signupVerified) {
      return <Redirect to="/subscription" />;
    }
    if (Success) {
      return <Redirect to="/signup/success" />;
    }
    if (!fetchingComplete && !(Success || this.props.Error)) {
      return <Loader />;
    }
    return (
      <div className="">
        <div className="textRequired">* Required Cells</div>
        <DataPolicy open={this.state.openDataPolicy} handleClose={this.closeDataPolicyModal}/>
        <div className="mainform">
          <p className="loginHeader">Create Your NTRAC's Farmer account</p>

          <InputFiled
            value={user.lastName}
            label="Last Name"
            required
            type="text"
            name="lastName"
            validations={["required", "minSize", "maxSize"]}
            handleError={this.handleError}
            handleChange={this.handleChange}
          />
          <InputFiled
            value={user.firstName}
            label="First Name"
            required
            type="text"
            name="firstName"
            validations={["required", "minSize", "maxSize"]}
            handleError={this.handleError}
            handleChange={this.handleChange}
          />
          <InputFiled
            value={user.username}
            placeholder="example@mail.com"
            label="Email/Username"
            type="email"
            validations={["email", "required"]}
            handleChange={this.handleChange}
            handleError={this.handleError}
            name="username"
            required
          />
          {Error.length > 0 && <div className="error">{Error}</div>}
          <InputFiled
            label="Password"
            value={user.password}
            required
            handleChange={this.handleChange}
            handleError={this.handleError}
            validations={["password", "required"]}
            type="password"
            name="password"
          />
          <InputFiled
            value={user.confirmPassword}
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            required
            validations={["required"]}
            handleChange={this.handleChange}
            handleError={this.handleError}
          />
          {!this.validateResetForm() && (
            <FormHelperText>
              <span className="error" role="alert">
                Your password confirmation did not match your password
              </span>
            </FormHelperText>
          )}
          <InputFiled
            label="Street Address"
            value={user.streetAddress}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            multiline
            rows={2}
            rowsMax={4}
            type="text"
            name="streetAddress"
          />
          <InputFiled
            label="Town/City"
            value={user.town}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="town"
          />
          <InputFiled
            label="State"
            value={user.state}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="state"
          />
          <InputFiled
            label="Zip Code"
            value={user.zipCode}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="zipCode"
          />
          <InputFiled
            label="Contact Phone Number"
            required
            value={user.contactNo}
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="contactNo"
          />
          <InputFiled
            label="Name of the Farm"
            value={user.farmName}
            handleChange={this.handleChange}
            handleError={this.handleError}
            validations={["required"]}
            required
            type="text"
            name="farmName"
          />
          <InputFiled
            label="Size of the Farm (in Acres)"
            value={user.farmSize}
            type="text"
            validations={["onlyNumber"]}
            name="farmSize"
            handleChange={this.handleChange}
            handleError={this.handleError}
          />
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={termsAndConditionAccepted}
                  onChange={this.handleCheck}
                  name="termsAndConditionAccepted"
                  classes={{
                    root: classes.root,
                    checked: classes.checked
                  }}
                  style={{paddingTop:'0px'}}
                />
              }
              label={
                <div>
                  <span>I agree to the </span>
                  <Link to="/terms-and-conditions" style={{ color: "#00bc84" }}>
                    Terms and Conditions
                  </Link>{" and "} <br />
                  <span
                  primary
                  onClick={this.openDataPolicyModal}
                  style={{ color: "#00bc84" }}>
                    Data Policy
                  </span>
                  <span> of the website</span>
                </div>
              }
              className="mycheckbox"
            />
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={allowDataSharing}
                  onChange={this.handleCheck}
                  name="allowDataSharing"
                  classes={{
                    root: classes.root,
                    checked: classes.checked
                  }}
                />
              }
              label="Opt out from information sharing"
              className="mycheckbox"
            />
          </FormGroup>
          {Success.length > 0 && (
            <div className="success">
              {Success} <a href="/login"> Click here</a>
            </div>
          )}

          <div className="signInSection" style={signInSectionStyle}>
          {isSuperAdmin() && 
            <Link
              className="cancelButton"
              component="button"
              onClick={this.onCancel}
            >
            Cancel
          </Link>
          }
            <Button
              name="Continue"
              disabled={
                isValid ||
                !this.validateResetForm() ||
                !fetchingComplete ||
                !termsAndConditionAccepted
              }
              onclick={this.userSignup}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    userData: state,
    Error: state.user.Error,
    Success: state.user.Success
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ isuserexist, userRegister }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Signup));

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};



// WEBPACK FOOTER //
// ./src/components/public/Signup.js